import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import VueI18n from 'vue-i18n';

import axios from 'axios';

// axios.defaults.baseURL = "/basurl";
axios.interceptors.request.use(function(config){
  const lang = localStorage.getItem('lang');
  console.log(lang);
  if(lang == null){
    lang = 'zh-CN'
  }
  //判断请求的类型：如果是post请求就把默认参数拼到data里面；如果是get请求就拼到params里面
  if (config.method === 'post') {
    config.data = {
        lang:lang,
        ...config.data
    }
  } else if (config.method === 'get') {
    config.params = {
       lang:lang,
       ...config.data
    }
  }
  return config;
})
// import $ from 'jquery';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.use(VueI18n);
import cnLocale from './assets/lang/cn'
import enLocale from './assets/lang/en'
import knLocale from './assets/lang/kn'

const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  messages: {
    'zh-CN': {...cnLocale,}, // 中文语言包
    'zh-EN':{...enLocale,}, // 英文语言包
    'zh-KN':{...knLocale,}, // 韩文语言包
  }
});

Vue.config.productionTip = false
Vue.prototype.$axios = axios;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
